var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 0.666687C4.39935 0.666687 0.666016 4.40002 0.666016 9.00002C0.666016 13.6 4.39935 17.3334 8.99935 17.3334C13.5993 17.3334 17.3327 13.6 17.3327 9.00002C17.3327 4.40002 13.5993 0.666687 8.99935 0.666687ZM9.83268 13.1667H8.16602V11.5H9.83268V13.1667ZM9.83268 9.83335H8.16602V4.83335H9.83268V9.83335Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.762e333e925dfa9832533eb6ed8ec963.svg";
export { ForwardRef as ReactComponent };